import Dialog from "../../../design-system/primitives/components/Dialog/Dialog";
import VideoEmbed from "../../../design-system/components/Video/Video.jsx";
import type { HandbookVideo } from "../../../api/handbook";
import styles from "./HandbookVideoDialog.css";

type HandbookVideoDialogProps = {
  video: HandbookVideo;
  onClose: () => void;
};

const HandbookVideoDialog = ({ video, onClose }: HandbookVideoDialogProps) => {
  if (!video) return null;

  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title={video.title}
      description={video.description ?? ""}
      closeAriaLabel="Video schließen"
      size="large"
      contentSlot={
        video && (
          <div className={styles.video}>
            <VideoEmbed url={video.url} />
          </div>
        )
      }
    />
  );
};

export default HandbookVideoDialog;
